// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__u2Pwf","text":"SelectPayment_text__DCpvV","title":"SelectPayment_title__3HNbL","btn":"SelectPayment_btn__3uoQv"};